// API Configuration for the auth/users/credits client (asab-identity).
// Note: this is a separate axios instance (`authClient.ts`) from the app's
// main `client.ts` — moved here verbatim from @asabdev/asab-ui, see
// authClient.ts's header comment for why.
export const API_CONFIG = {
  // Default timeout for API requests
  TIMEOUT: 10000, // 10 seconds

  // Default base URL - should be overridden by the consuming app
  BASE_URL: import.meta.env.VITE_API_BASE_URL,
};

// Authentication settings
export const AUTH_TOKEN_KEY = 'authToken';

// API endpoints — mapped to asab-identity backend
export const API_ENDPOINTS = {
  // Authentication endpoints (public, no auth required)
  AUTH: {
    LOGIN: '/v1/auth/login',
    REGISTER: '/v1/auth/register',
    FORGOT_PASSWORD: '/v1/auth/forgot-password',
    RESET_PASSWORD: '/v1/auth/reset-password',
    VERIFY_EMAIL: '/v1/auth/verify-email',
    RESEND_VERIFICATION: '/v1/auth/resend-verification',
    REFRESH: '/v1/auth/refresh',
  },

  // User endpoints (authenticated)
  USERS: {
    ME: '/v1/users/me',
    DELETE: '/v1/users/me',
    BY_ID: (id: string) => `/v1/users/${id}`,
  },

  // Organization endpoints (authenticated)
  ORGANIZATIONS: {
    LIST: '/v1/organizations',
    CREATE: '/v1/organizations',
    BY_ID: (id: string) => `/v1/organizations/${id}`,
    UPDATE: (id: string) => `/v1/organizations/${id}`,
    DELETE: (id: string) => `/v1/organizations/${id}`,
    MEMBERS: (orgId: string) => `/v1/organizations/${orgId}/members`,
    INVITES: (orgId: string) => `/v1/organizations/${orgId}/invites`,
    DOMAINS: (orgId: string) => `/v1/organizations/${orgId}/domains`,
    API_KEYS: (orgId: string) => `/v1/organizations/${orgId}/api-keys`,
  },

  // Credits endpoints (authenticated)
  CREDITS: {
    ORG_CREDITS: (orgId: string) => `/v1/organizations/${orgId}/credits`,
    ADD: (orgId: string) => `/v1/organizations/${orgId}/credits/add`,
    DEDUCT: (orgId: string) => `/v1/organizations/${orgId}/credits/deduct`,
    CREDIT_USAGE: (orgId: string) => `/v1/organizations/${orgId}/credits/usage`,
    PAYMENT_METHODS: '/v1/payments/methods',
    PAYMENT_INTENT: (orgId: string) => `/v1/organizations/${orgId}/payments/intent`,
    PAYMENT_CONFIRM: (paymentId: string) => `/v1/payments/${paymentId}/confirm`,
    PAYMENT_STATUS: (paymentId: string) => `/v1/payments/${paymentId}`,
    PAYMENT_HISTORY: (orgId: string) => `/v1/organizations/${orgId}/payments/history`,
    PAYMENT_CANCEL: (paymentId: string) => `/v1/payments/${paymentId}/cancel`,
    PAYMENT_WEBHOOK: '/v1/payments/webhook',
  },

  // Health check
  HEALTH: '/health',
} as const;
